import { QueryClient } from 'react-query';
import axios from './axios';

export function queryFnFactory(options = {}) {
  return async ({ queryKey, pageParam }) => {
    // clone to avoid mutating queryKey
    const items = [...queryKey];
    const queryStringObj = { ...(items.find((i) => typeof i === 'object') || {}) };

    // inject pageParam safely
    if (pageParam) {
      const paginationKey = typeof pageParam === 'string' ? 'cursor' : 'page';
      queryStringObj[paginationKey] = pageParam;
    }

    let url = items.filter((i) => typeof i !== 'object').join('/');
    if (!url.startsWith('/')) url = `/${url}`;

    const { data } = await axios.request({
      method: 'get',
      url,
      params: queryStringObj,
      ...options,
    });

    return data;
  };
}

function queryClientFactory() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        retry: (failureCount, err) => 3 > failureCount && ![401, 403, 404, 426].includes(err.response?.status),
        queryFn: queryFnFactory(),
        useErrorBoundary: (error) => 500 <= error.response?.status,
        notifyOnChangeProps: 'tracked',
      },
    },
  });
}

export default queryClientFactory();
